export default "__VITE_ASSET__101c4f06__"